import React, { Component } from "react";
import CreateMerchantGatewayRatesTable from "./CreateMerchantGatewayRatesTable";
import CreateMerchantStripeRatesTable from "./CreateMerchantStripeRatesTable";

class CreateMerchantGatewayRates extends Component {
	constructor(props) {
		super(props);

		this.state = {
			baseRate: props.baseRate,
		};
	}

	componentDidUpdate(prevProps) {
		if (
			JSON.stringify(prevProps.baseRate) !== JSON.stringify(this.props.baseRate)
		)
			this.setState({ baseRate: this.props.baseRate });
	}

	render() {
		const {
			MDRTypes,
			enable,
			gateway,
			gatewayCurrency,
			enableRate,
			setGatewayRates,
		} = this.props;
		const { baseRate } = this.state;

		if (gateway !== "stripe")
			return (
				<>
					<div className="uk-flex">
						<div className="uk-width-1-6 uk-padding-small uk-padding-remove-horizontal uk-margin-small-top uk-margin-right">
							<ul
								className="uk-tab-left"
								uk-tab={`connect: #${gateway}-currency-rates`}
							>
								{gatewayCurrency[gateway] &&
									gatewayCurrency[gateway].map((currency, index) => (
										<li
											key={`${gateway}-${currency.name}`}
											className={`${index === 0 ? "uk-active" : ""}`}
										>
											<a href="#">{currency.name}</a>
										</li>
									))}
							</ul>
						</div>
						<div className="uk-width-5-6 uk-padding-small uk-padding-remove-vertical">
							<ul id={`${gateway}-currency-rates`} className="uk-switcher">
								{gatewayCurrency[gateway] &&
									gatewayCurrency[gateway].map((currency) => (
										<li key={`${gateway}-${currency.name}-rates`}>
											<CreateMerchantGatewayRatesTable
												MDRTypes={MDRTypes}
												baseRate={baseRate}
												currency={currency.code}
												gateway={gateway}
												enable={enable}
												enableRate={enableRate}
												setGatewayRates={setGatewayRates}
											/>
										</li>
									))}
							</ul>
						</div>
					</div>
				</>
			);

		return (
			<CreateMerchantStripeRatesTable
				MDRTypes={MDRTypes}
				baseRate={baseRate}
				gateway={gateway}
				enable={enable}
				enableRate={enableRate}
				setGatewayRates={setGatewayRates}
			/>
		);
	}
}

export default CreateMerchantGatewayRates;
